import adsApi from '@/backend/services/googleAds/googleAds.js';
import api from '@/client/services/home/home.js';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	state: {
		warningType: [],
		operatList: [],
		searchDataCheckboxData: false, // 搜索词报告，图表仅看已添加
		finishValue: 1,
	},
	mutations: {
		SET_WARNINGTYPE(state, data) {
			state.warningType = data;
		},
		SET_OPERATLIST(state, data) {
			state.operatList = data;
		},
		SET_SEARCHDATACHECKBOXDATA(state, data) {
			state.searchDataCheckboxData = data;
		},
		SET_FINISHVALUE(state, data) {
			state.finishValue = data;
		},
	},
	actions: {
		getWarningType({ commit }) {
			return new Promise((resolve, reject) => {
				adsApi
					.ruleTreeList()
					.then(res => {
						commit('SET_WARNINGTYPE', res.data);
						resolve(res.data);
					})
					.catch(e => {
						reject(e);
					});
			});
		},
		getOperatList({ commit }) {
			return new Promise((resolve, reject) => {
				adsApi
					.operatList()
					.then(res => {
						commit('SET_OPERATLIST', res.data);
						resolve(res.data);
					})
					.catch(e => {
						reject(e);
					});
			});
		},
		async adsLanguageReport(context, language) {
			try {
				let res = await api.getLanguageReport({ language });
				return Promise.resolve(res);
			} catch (e) {
				return Promise.reject(e);
			}
		},
		async getstepstatus({ commit }, value) {
			let res = await adsNewOnline.getstepstatus({ id: value });
			if (res.data) {
				commit('SET_FINISHVALUE', res.data.stepStatus >= 5 ? 6 : res.data.stepStatus);
			}
		},
	},
};
